module.exports = __webpack_public_path__ + "h5/img/logo2.f6d6e6b4.png";